import { Component, OnInit } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { VeiculoService } from 'src/app/services/veiculo.service';
import { FilterService } from 'src/app/services/filter.service';
import { Constants } from 'src/app/app-constants';

@Component({
  selector: 'app-carros',
  templateUrl: './carros.component.html',
  styleUrls: ['./carros.component.css']
})
export class CarrosComponent implements OnInit {

  loading = false;
  arrCarros: any = [];
  constants: any = Constants;

  filterItens: any = {
    'companies': '',
    'marcaModelo': '',
    'years': '',
    'tp_person': '',
  };

  filteredModel = [];

  public formCar: any = {
    cadastro: '',
    empresa: '',
    veiculo: '',
    marca: '',
    modelo: '',
    ano: '',
    tipo: '',
    contato: ''
  };

  public formNotificacaoCar: any = {
    purl: '',
    titulo: '',
    tp: '',
    msg: '',
  };

  marcas: any = [];

  masterSelected: Boolean = true;
  filteredCars: String = '';
  active: boolean = false;

  constructor(private notify: SnotifyService, private Veiculo: VeiculoService, private Filter: FilterService) { }

  onSubmit() {
    this.loading = true;
    this.active = false;
    this.getCarListByForm(
      this.formCar.modelo, this.formCar.veiculo, this.formCar.ano, this.formCar.marca, this.formCar.empresa, this.formCar.cadastro
    );
  }

  toggleAll() {
    this.arrCarros.forEach(e => {
      e.send = this.masterSelected;
    });

    this.updateFilteredCars();
  }

  updateMasterSelected() {

    this.masterSelected = this.arrCarros.every((e) => {
      return e.send;
    });

    this.updateFilteredCars();

  }

  updateFilteredCars(){
    this.filteredCars = this.arrCarros.filter(carro => {
      return carro.send;
    }).map(carro => {
      return carro.licensePlate;
    }).join(',');
  }

  filterModel() {
    this.filteredModel = this.filterItens.modelos.filter(modelo => {
      return modelo.id_marca == this.formCar.marca
    });
  }

  getCarListByForm(model = '', vehicleType = '', year = '', brand = '', company = '', userType = '') {
    this.Filter.getCarLista(model, vehicleType, year, brand, company, userType).subscribe(
      result => {
        this.active = true;
        this.loading = false;
        this.arrCarros = result;
        this.arrCarros.forEach(carro => {
          carro.send = true;
        });
        this.updateFilteredCars();
      },
      error => {
        this.loading = false;
        this.notify.error('Erro ao retornar os usuários', { timeout: 3000, showProgressBar: false });
      }
    );
  }

  submitNotificacoes() {
    this.loading = true;

    if(this.formNotificacaoCar.tp == ""){
      alert('Campo "tipo de notificação" é obrigatório');
      this.loading = false;
      return;
    } else if(this.filteredCars == ""){
      alert('É preciso selecionar ao menos um destinatário');
      this.loading = false;
      return;
    } else if(this.formNotificacaoCar.titulo == ""){
      alert('Campo "título" é obrigatório');
      this.loading = false;
      return;
    }

    this.Filter.sendNotificationByPlate(this.formNotificacaoCar.purl, this.formNotificacaoCar.titulo, this.formNotificacaoCar.msg, this.filteredCars, this.formNotificacaoCar.tp).subscribe(
      result => {
        this.loading = false;
        alert('Notificação Enviada');
      },
      error => {
        this.loading = false;
        alert('Notificação não Enviada');
      }
    );
  }

  ngOnInit() {
    this.loading = true;
    this.Filter.getFilterCarParams().subscribe(
      result => {
        this.filterItens = result;
      },
      error => {
        console.log('error');
        console.log(error);
      }
    );

    this.getCarListByForm();
  }

  downloadCSV() {
    this.loading = true;
    this.active = true;

    try {
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.href = `${this.constants.apiMautic}/filter/search_by_car_csv?model=${this.formCar.modelo}&vehicleType=${this.formCar.veiculo}&year=${this.formCar.ano}&brand=${this.formCar.marca}&company=${this.formCar.empresa}&usrType=${this.formCar.cadastro}`;
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
      this.loading = false;

    } catch (error) {
      console.error('Error =>', error);
      this.loading = false;
      this.notify.error('Erro ao retornar os veículos', {timeout: 3000, showProgressBar: false });
    }

    // this.Filter.getCarListaCSV(this.formCar.modelo, this.formCar.veiculo, this.formCar.ano,
    //   this.formCar.marca, this.formCar.empresa, this.formCar.cadastro).subscribe(
    //   result => {
    //     this.loading = false;
    //   },
    //   error => {
    //     this.loading = false;
    //     this.notify.error('Erro ao retornar os veículos', {timeout: 3000, showProgressBar: false });
    //   }
    // );
  }

}
